import {Button} from 'components/system/Button'
import moment from 'moment'
import {useExploreMorePath} from 'providers/EnvironmentProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {useCallback, useEffect} from 'react'

export const Timeout = () => {
  const order = OrderProvider.useOrder('optional')
  const setOrder = OrderProvider.useOrderSetter()
  const exploreMorePath = useExploreMorePath()

  const onClick = useCallback(() => {
    window.location.href = exploreMorePath
  }, [exploreMorePath])

  useEffect(() => {
    if (order && moment.utc(order.utcExpiresAt).isSameOrBefore(moment())) {
      setOrder(null)
    }
  }, [order, setOrder])

  return (
    <div className="w-full d:w-[426px] mx-auto px-4 d:px-0 flex flex-col items-center py-[72px]">
      <div className="text-[32px] font-bold">Oops, Time's Up!</div>
      <div className="text-center">
        Your reservation has timed out, and your cart is empty. Let's discover new experiences together!
      </div>
      <Button.Primary.Orange onClick={onClick} autoExpanded className="mt-8">
        Discover More
      </Button.Primary.Orange>
    </div>
  )
}
